import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {getSalesChannelsAPI} from "../../api/salesChannel";

/**
 * Kanali kroz koje se prodaju alotmani prijavljenog prevoznika — server sam
 * sužava listu na osnovu dodeljenih alotmana. Prazna lista znači da prevoznik
 * nema drugih kanala prodaje, pa mu se ta sekcija i ne nudi u meniju.
 */
export const fetchSalesChannels = createAsyncThunk("fetchSalesChannels", async () => {
    const {data} = await getSalesChannelsAPI();
    return Array.isArray(data) ? data : [];
});

const initialState = {
    channels: [],
    loading: false,
    fetched: false,
};

const slice = createSlice({
    name: "salesChannels",
    initialState,
    reducers: {},
    extraReducers: {
        [fetchSalesChannels.pending]: (state) => {
            state.loading = true;
        },
        [fetchSalesChannels.fulfilled]: (state, {payload}) => {
            state.channels = payload;
            state.loading = false;
            state.fetched = true;
        },
        [fetchSalesChannels.rejected]: (state) => {
            state.loading = false;
            state.fetched = true;
        },
    },
});

export default slice.reducer;
